// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class NpiTaxonomyResponseModel {
    'code'?: string;
    'taxonomy_group'?: string;
    'desc'?: string;
    'state'?: string;
    'license'?: string;
    'primary'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof NpiTaxonomyResponseModel>> = [
        {
            "name":     "code",
            "baseName": "code",
            "type":     "string"
        },
        {
            "name":     "taxonomy_group",
            "baseName": "taxonomy_group",
            "type":     "string"
        },
        {
            "name":     "desc",
            "baseName": "desc",
            "type":     "string"
        },
        {
            "name":     "state",
            "baseName": "state",
            "type":     "string"
        },
        {
            "name":     "license",
            "baseName": "license",
            "type":     "string"
        },
        {
            "name":     "primary",
            "baseName": "primary",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return NpiTaxonomyResponseModel.attributeTypeMap;
    }
}
